import Picture, { PictureFallbackImage, PictureSource } from "src/components/images/Picture";
import { type IContentFilmList } from "src/lib/types/ContentFilmList";
import styles from "./InlineFilmListBanner.module.css";

//#region [Props]
type InlineFilmListBannerProps = {
    filmList: IContentFilmList<true>;
};
//#endregion

//#region [Component]
export default function InlineFilmListBanner({ filmList }: InlineFilmListBannerProps) {
    return <div>
        {filmList.imageDesktop && filmList.imageMobile && <Picture >
            <PictureSource media="(min-width: 400px)" cmsImage={filmList.imageDesktop} width={720} />
            <PictureFallbackImage cmsImage={filmList.imageMobile} alt={filmList.imageDesktop?.asset?.altText ?? filmList?.imageMobile?.asset?.altText ?? filmList.title} width={780} className={styles.TopImage} />
        </Picture>}
    </div>;
}
//#endregion
